module.exports = __webpack_public_path__ + "surnames.45557cd1e3442718b5f91c91001b743e.json";